import React from "react";
import AppVersionSettingsContainer from "../../modules/GAAppVersionSettings/containers/AppVersionSettingsContainer/AppVersionSettingsContainer";

const GAAppVersionSettings = () => {
  return <AppVersionSettingsContainer />;
};

export default GAAppVersionSettings;
